import type { BusinessAuthMessage } from './authTypes';

export const businessAuthMessages: Record<BusinessAuthMessage, string> = {
  BusinessSignupAccepted: 'Check your email for the verification code.',
  BusinessVerificationResendAccepted: 'If an unverified account is available, a verification code has been sent.',
  BusinessPasswordResetAccepted: 'If an account exists for this email, a password reset code has been sent.',
  BusinessEmailVerificationSucceeded: 'Your email has been verified. You can now sign in.',
  BusinessPasswordResetSucceeded: 'Your password has been reset. You can now sign in.',
  BusinessSignInSucceeded: 'Signed in successfully.',
  AccountAlreadyExists: 'An account with this email already exists. Sign in or reset your password.',
  MissingBodyInRequest: 'The request is missing required information.',
  MissingRequiredFields: 'Please complete all required fields.',
  InvalidEmail: 'Enter a valid email address.',
  InvalidRequest: 'The request is invalid.',
  InvalidPassword: 'Use at least 12 characters with uppercase, lowercase, a number, and a symbol.',
  InvalidEmailOrPassword: 'Invalid email or password.',
  InvalidOrExpiredVerificationCode: 'The verification code is invalid or expired.',
  RateLimited: 'Too many attempts. Please wait and try again.',
  InternalError: 'Something went wrong. Please try again.',
};

export function getBusinessAuthMessage(message: string | null | undefined, fallback: string): string {
  return (
    (message && message in businessAuthMessages ? businessAuthMessages[message as BusinessAuthMessage] : message) ||
    fallback
  );
}
